import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignSelectStudioLink({
  campaignGuid
}) {
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    as: "p",
    color: "text-core-subtle",
    paddingBlockStart: "300",
    paddingBlockEnd: "0",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "campaignSelect.seenStudio.formControlSubline_jsx",
      elements: {
        Link
      },
      options: {
        external: true,
        href: `/marketing/${PortalIdParser.get()}/studio/${campaignGuid}`,
        target: '_blank',
        underline: true,
        typography: 'detail-100'
      }
    })
  });
}